export var getInitialOptionsCache = function getInitialOptionsCache(_ref) {
  var options = _ref.options,
      defaultOptions = _ref.defaultOptions,
      additional = _ref.additional,
      defaultAdditional = _ref.defaultAdditional;
  var initialOptions = defaultOptions === true ? null : defaultOptions instanceof Array ? defaultOptions : options;

  if (initialOptions) {
    return {
      '': {
        isFirstLoad: false,
        isLoading: false,
        options: initialOptions,
        hasMore: true,
        additional: defaultAdditional || additional
      }
    };
  }

  return {};
};